import { authenticatedHeadersHash } from "views_shared/app/javascript/scripts/authentication";

export const SUPABASE_URL = () => globalThis.Qwoted.SUPABASE_API_EXTERNAL_URL;
export const QUEUE_RESOURCE = "admin_user_verification_queue";
export const RULES_URL = "/admin/api/user_verification_rules";
export const DECISIONS_URL = "/admin/api/user_verification_decisions";

export function writeHeaders() {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
  return { ...authenticatedHeadersHash(), "Content-Type": "application/json", "X-CSRF-Token": csrfToken };
}

export function humanize(value) {
  if (!value) return "";
  const text = value.replace(/_/g, " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
}

export const RULE_ACTION_LABELS = {
  mark_suspicious: "Mark suspicious",
  set_under_audit: "Set under audit",
};

export const OUTCOME_LABELS = {
  no_action: "No action",
  suspicious: "Suspicious",
  under_audit: "Under audit",
};

export const OUTCOME_BADGE = {
  under_audit: "bg-danger",
  suspicious: "bg-warning text-dark",
  no_action: "bg-light text-dark border",
};

export const VERDICT_BADGE = {
  audit_lifted: "bg-success",
  audit_kept: "bg-secondary",
  disabled: "bg-dark",
  vetted: "bg-success",
  set_under_audit: "bg-danger",
};

export const VERDICT_LABELS = {
  audit_lifted: "Audit lifted",
  audit_kept: "Audit kept",
  disabled: "Disabled",
  vetted: "Vetted",
  set_under_audit: "Set under audit",
};

// A decision nobody gave a verdict that left the queue because of a change made elsewhere.
export const RESOLVED_ELSEWHERE_LABELS = {
  vetted: "Vetted elsewhere",
  disabled: "Disabled elsewhere",
  audited: "Audited elsewhere",
  audit_changed: "Audit changed elsewhere",
};

// The geo-IP snapshot's role values.
export const USER_TYPE_LABELS = {
  media: "Media",
  promoter: "Source",
};

export const IP_SOURCE_LABELS = {
  current_sign_in_ip: "latest sign-in",
  signup_visit: "signup visit",
};
